webpackJsonp([1],{

/***/ "+jqP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1we+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var appId = 'u4CoaEwHtInP8VCYCUDnAEZacCyzbFv0';
var appSecret = '6xU47BazKuvjLutlVhZbRk81p4X5XbS4';
var locationId = '1';
/* harmony default export */ __webpack_exports__["a"] = ({
	$ajax: function $ajax(options, secretRequired, sessionToken) {
		var localhost = 'https://ecomm.api.unoapp.io/api';
		options.url = localhost + options.url;

		if (secretRequired) {
			options.beforeSend = function (xhr) {
				xhr.setRequestHeader('app-id', appId);
				xhr.setRequestHeader('app-secret', appSecret);
				if (sessionToken) {
					xhr.setRequestHeader('auth-token', sessionToken);
				}
			};
		}
		__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax(options);
	},
	getLocation: function getLocation() {
		return locationId;
	}
});

/***/ }),

/***/ "6+h/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global__ = __webpack_require__("3Lce");




/* harmony default export */ __webpack_exports__["a"] = ({
	addToCart: function addToCart(cart) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__global__["a" /* default */].$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/cart/addtocart',
				data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cart),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error) {
					reject(_error);
				}
			}, true);
		});
	},
	emptyCart: function emptyCart() {
		var _this = this;

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__global__["a" /* default */].$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/cart/empty',
				data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'cart_id': _this.$root.cartId }),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error2) {
					reject(_error2);
				}
			}, true);
		});
	},
	getCart: function getCart(cartId) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__global__["a" /* default */].$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/cart/' + cartId + '/show',
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error3) {
					reject(_error3);
				}
			}, true);
		});
	},
	placeOrder: function placeOrder(obj) {
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__global__["a" /* default */].$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/order/place',
				data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error4) {
					reject(_error4);
				}
			}, true);
		});
	}
});

/***/ }),

/***/ "8qvv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CGH0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/controllers/Location.js
var Location = __webpack_require__("SjVX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MyFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MyFooter = ({
	name: 'MyFooter',
	data: function data() {
		return {
			locationData: {},
			locationHours: []
		};
	},
	mounted: function mounted() {
		this.getHours();
		this.getLocation();
	},

	methods: {
		return12H: function return12H(val) {
			console.log(val);
			var arr = val.split(':');
			var type = 'am';
			if (arr[0] > 12) {
				type = 'pm';
				arr[0] = arr[0] - 12;
			} else {
				arr[0] = arr[0] - 0;
			}
			return arr[0] + ':' + arr[1] + type;
		},
		getHours: function getHours() {
			var _this = this;

			Location["a" /* default */].getLocationHours().then(function (response) {
				_this.locationHours = response.payload;
			}).catch(function (e) {});
		},
		getLocation: function getLocation() {
			var _this2 = this;

			Location["a" /* default */].getLocation().then(function (response) {
				_this2.locationData = response.payload;
			}).catch(function (e) {});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df04d8f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyFooter.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"wrapper footer-wrapper"},[_c('div',{staticClass:"footer-left"},[_c('h5',{staticClass:"tertiary-heading"},[_vm._v(" "+_vm._s(_vm.locationData.display_name)+" ")]),_vm._v(" "),_c('ul',[_c('li',[_c('h6',{staticClass:"tertiary-copy"},[_vm._v(" "+_vm._s(_vm.locationData.address_line_1)+" ")])]),_vm._v(" "),_c('li',[_c('h6',{staticClass:"tertiary-copy"},[_vm._v(" "+_vm._s(_vm.locationData.city)+", "+_vm._s(_vm.locationData.province)+" ")])]),_vm._v(" "),_c('li',[_c('h6',{staticClass:"tertiary-copy"},[_vm._v(" "+_vm._s(_vm.locationData.postal_code))])]),_vm._v(" "),_c('li',[_c('h6',{staticClass:"tertiary-copy"},[_vm._v(" "+_vm._s(_vm.locationData.country)+" ")])]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('li',[_c('h6',{staticClass:"tertiary-copy"},[_vm._v(" "+_vm._s(_vm.locationData.phone)+" ")])]),_vm._v(" "),_c('h6',{staticClass:"tertiary-copy"},[_vm._v(" "+_vm._s(_vm.locationData.email))]),_vm._v(" "),_vm._m(1,false,false)])]),_vm._v(" "),_c('div',{staticClass:"footer-right"},[_c('h5',{staticClass:"tertiary-heading"},[_vm._v("Hours of Operation")]),_vm._v(" "),_c('ul',_vm._l((_vm.locationHours),function(day){return _c('li',[_c('h6',{staticClass:"tertiary-copy"},[_c('div',{staticStyle:{"width":"80px","display":"inline-block"}},[_vm._v(" \n\t\t\t\t\t\t"+_vm._s(day.day_name)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.return12H(day.open_time))+" - "+_vm._s(_vm.return12H(day.close_time))+"\n\t\t\t\t\t")])])])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"keyline"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"keyline"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_MyFooter = (esExports);
// CONCATENATED MODULE: ./src/components/MyFooter.vue
function injectStyle (ssrContext) {
  __webpack_require__("j7sp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df04d8f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MyFooter,
  components_MyFooter,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_MyFooter = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/global.js
var global = __webpack_require__("3Lce");

// CONCATENATED MODULE: ./src/controllers/Menu.js



/* harmony default export */ var Menu = ({
	getMenu: function getMenu() {
		return new promise_default.a(function (resolve, reject) {
			global["a" /* default */].$ajax({
				method: 'GET',
				dataType: 'json',
				url: '/app/menus/full/' + global["a" /* default */].getLocation(),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error) {
					reject(_error);
				}
			}, true);
		});
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
	name: 'app',
	created: function created() {
		this.loadMenuData();
	},
	data: function data() {
		return {
			hours: false
		};
	},

	methods: {
		loadMenuData: function loadMenuData() {
			var _this = this;

			Menu.getMenu().then(function (response) {
				var categories = response.payload;
				var newCategory = void 0;
				categories.forEach(function (category) {
					if (category.length !== 0) {
						if (category.name !== 'Menu' && category.categories.length > 0) {
							newCategory = {
								name: category.name,
								id: category.id,
								items: category.categories[0].items
							};
							_this.$root.categories.push(newCategory);
						}
					}
				});
				localStorage.setItem('categories', newCategory);
			}).catch(function (reason) {
				console.log(reason);
			});
		},
		handleAddItem: function handleAddItem(item) {
			this.$emit('addItem', item);
		},
		openHours: function openHours() {
			this.hours = !this.hours;
		}
	},
	components: {
		MyFooter: src_components_MyFooter
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14b808f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{on:{"addItem":_vm.handleAddItem,"openHours":_vm.openHours}}),_vm._v(" "),(this.$route.name !== 'Login' && this.$route.name !== 'ConfirmOrder')?_c('my-footer'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.hours)?_c('div',{staticClass:"hours-box",on:{"click":_vm.openHours}},[_c('ul',{staticClass:"hours"},[_c('li',[_c('h3',{staticClass:"subheading"},[_vm._v("Hours of Operation")])]),_vm._v(" "),_c('li',[_c('h4',{staticClass:"secondary-copy"},[_vm._v("Monday 5pm - 11pm")])]),_vm._v(" "),_c('li',[_c('h4',{staticClass:"secondary-copy"},[_vm._v("Tuesday 5 - 11pm")])]),_vm._v(" "),_c('li',[_c('h4',{staticClass:"secondary-copy"},[_vm._v("Wednesday 11:30am - 11pm")])]),_vm._v(" "),_c('li',[_c('h4',{staticClass:"secondary-copy"},[_vm._v("Thursday 11:30am - 11pm")])]),_vm._v(" "),_c('li',[_c('h4',{staticClass:"secondary-copy"},[_vm._v("Friday 11:30am - 12am")])]),_vm._v(" "),_c('li',[_c('h4',{staticClass:"secondary-copy"},[_vm._v("Saturday 2pm - 12am")])]),_vm._v(" "),_c('li',[_c('h4',{staticClass:"secondary-copy"},[_vm._v("Sunday 2pm - 11pm")])])])]):_vm._e()])],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("ZxdY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ItemViewer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ItemViewer = ({
	name: 'ItemViewer',
	props: ['selectedItem', 'viewingItem'],
	data: function data() {
		return {
			specialInstructions: ''
		};
	},

	computed: {
		editOrAdd: function editOrAdd() {
			if (this.selectedItem.edit) {
				return 'Update Item';
			}
			return 'Add Item';
		}
	},
	methods: {
		increment: function increment() {
			this.$emit('addOne');
		},
		decrement: function decrement() {
			if (this.selectedItem.qty !== 1) {
				this.$emit('subtractOne');
			}
		},
		handleAddItem: function handleAddItem() {
			this.$emit('addItem', this.specialInstructions);
			this.$emit('close', this.selectedItem.edit);
			this.quantity = 1;
			this.specialInstructions = '';
		},
		close: function close(e) {
			if (e.target.classList.contains('item-viewer')) {
				this.$emit('close');
				this.quantity = 1;
				this.specialInstructions = '';
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3604d24f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemViewer.vue
var ItemViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewingItem)?_c('div',{on:{"click":_vm.close}},[_c('div',{staticClass:"item-viewer--content"},[_c('div',{staticClass:"item-viewer--item-info"},[_c('h3',{staticClass:"tertiary-heading"},[_vm._v(_vm._s(_vm.selectedItem.name))]),_vm._v(" "),_c('h4',{staticClass:"primary-copy"},[_vm._v("$"+_vm._s(_vm.selectedItem.price))]),_vm._v(" "),(_vm.selectedItem.desc !== _vm.selectedItem.name)?_c('h4',{staticClass:"primary-copy"},[_vm._v(_vm._s(_vm.selectedItem.desc))]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"item-viewer--item-data",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"item-data--top"},[_c('label',{staticClass:"primary-copy",attrs:{"for":"specialInstructions"}},[_vm._v("Special Instructions")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.specialInstructions),expression:"specialInstructions"}],staticClass:"primary-copy special-instructions",attrs:{"name":"specialInstructions","id":"specialInstructions","cols":"50","rows":"4"},domProps:{"value":(_vm.specialInstructions)},on:{"input":function($event){if($event.target.composing){ return; }_vm.specialInstructions=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"item-data--bottom"},[_c('div',{staticClass:"item-data--quantity-control"},[_c('a',{on:{"click":_vm.decrement}},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.qty),expression:"selectedItem.qty"}],attrs:{"type":"text","id":"quantity","disabled":""},domProps:{"value":(_vm.selectedItem.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedItem, "qty", $event.target.value)}}}),_vm._v(" "),_c('a',{on:{"click":_vm.increment}},[_c('i',{staticClass:"fa fa-plus"})])]),_vm._v(" "),_c('button',{staticClass:"item-data--submit",on:{"click":_vm.handleAddItem}},[_vm._v(_vm._s(_vm.editOrAdd))])])])])]):_vm._e()}
var ItemViewer_staticRenderFns = []
var ItemViewer_esExports = { render: ItemViewer_render, staticRenderFns: ItemViewer_staticRenderFns }
/* harmony default export */ var components_ItemViewer = (ItemViewer_esExports);
// CONCATENATED MODULE: ./src/components/ItemViewer.vue
function ItemViewer_injectStyle (ssrContext) {
  __webpack_require__("+jqP")
}
var ItemViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ItemViewer___vue_template_functional__ = false
/* styles */
var ItemViewer___vue_styles__ = ItemViewer_injectStyle
/* scopeId */
var ItemViewer___vue_scopeId__ = "data-v-3604d24f"
/* moduleIdentifier (server only) */
var ItemViewer___vue_module_identifier__ = null
var ItemViewer_Component = ItemViewer_normalizeComponent(
  ItemViewer,
  components_ItemViewer,
  ItemViewer___vue_template_functional__,
  ItemViewer___vue_styles__,
  ItemViewer___vue_scopeId__,
  ItemViewer___vue_module_identifier__
)

/* harmony default export */ var src_components_ItemViewer = (ItemViewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Cart.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Cart = ({
	name: 'Cart',
	props: ['cartOpen'],
	methods: {
		close: function close(e) {
			if (e.target.classList.contains('cart-container')) {
				this.$emit('close');
			}
		},
		editItem: function editItem(e) {
			if (!e.target.classList.contains('delete-item')) {
				var itemId = parseInt(e.target.parentNode.dataset.item);
				this.$emit('edit', itemId);
			}
		},
		removeItem: function removeItem(e) {
			var itemId = parseInt(e.target.dataset.item);
			this.$emit('remove', itemId);
		},
		handleCheckout: function handleCheckout() {
			this.$emit('checkout');
		}
	},
	computed: {
		cart: function cart() {
			return this.$root.cart;
		},
		total: function total() {
			var total = 0;
			this.cart.forEach(function (item) {
				total = total + parseFloat(item.price) * parseFloat(item.qty);
			});
			return total.toFixed(2);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c653c00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart.vue
var Cart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-container",on:{"click":_vm.close}},[(_vm.cartOpen)?_c('div',{staticClass:"cart-content"},[_c('div',{staticClass:"cart-top",staticStyle:{"overflow-y":"auto","min-height":"80%"}},[_c('h2',{staticClass:"heading"},[_vm._v("Cart")]),_vm._v(" "),(_vm.cart.length === 0)?_c('h3',{staticStyle:{"text-align":"center","font-size":"25px","margin-top":"20%","font-family":"'Raleway', sans-serif"}},[_vm._v(" Your Cart is empty!")]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.cart),function(item){return _c('li',{staticClass:"cart-item"},[_c('div',{staticClass:"cart-item-top",attrs:{"data-item":item.id},on:{"click":_vm.editItem}},[_c('h3',{staticClass:"tertiary-heading cart-item-top--name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading cart-item-top--quantity"},[_vm._v("x "+_vm._s(item.qty))]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading cart-item-top--price"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"cart-item-top--buttons"},[_c('button',{staticClass:"delete-item",attrs:{"data-item":item.id},on:{"click":_vm.removeItem}})])]),_vm._v(" "),_c('div',{staticClass:"cart-item-bottom"},[(item.desc !== item.name)?_c('h4',{staticClass:"primary-copy"},[_vm._v(_vm._s(item.desc))]):_vm._e(),_vm._v(" "),(item.specialInstructions)?_c('h4',{staticClass:"primary-copy special-instructions"},[_vm._v("("+_vm._s(item.specialInstructions)+")")]):_vm._e()])])}))]),_vm._v(" "),_c('div',{staticClass:"cart-bottom"},[_c('div',{staticClass:"cart-total"},[_c('h2',{staticClass:"subheading cart-total-copy"},[_vm._v("Subtotal:")]),_vm._v(" "),_c('h2',{staticClass:"tertiary-heading cart-total-number"},[_vm._v("$"+_vm._s(_vm.total))])]),_vm._v(" "),_c('div',{staticClass:"cart-buttons"},[(this.cart.length > 0)?_c('button',{staticClass:"checkout primary-button",on:{"click":_vm.handleCheckout}},[_vm._v("Checkout")]):_vm._e()])])]):_vm._e()])}
var Cart_staticRenderFns = []
var Cart_esExports = { render: Cart_render, staticRenderFns: Cart_staticRenderFns }
/* harmony default export */ var components_Cart = (Cart_esExports);
// CONCATENATED MODULE: ./src/components/Cart.vue
function Cart_injectStyle (ssrContext) {
  __webpack_require__("Rum2")
}
var Cart_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Cart___vue_template_functional__ = false
/* styles */
var Cart___vue_styles__ = Cart_injectStyle
/* scopeId */
var Cart___vue_scopeId__ = "data-v-7c653c00"
/* moduleIdentifier (server only) */
var Cart___vue_module_identifier__ = null
var Cart_Component = Cart_normalizeComponent(
  Cart,
  components_Cart,
  Cart___vue_template_functional__,
  Cart___vue_styles__,
  Cart___vue_scopeId__,
  Cart___vue_module_identifier__
)

/* harmony default export */ var src_components_Cart = (Cart_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConfirmOrder.vue
var ConfirmOrder = __webpack_require__("SREL");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0702cc6b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmOrder.vue
var ConfirmOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"confirm"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"login-nav"},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"img-box login"},[_c('img',{attrs:{"src":__webpack_require__("rNDY"),"alt":"An image of our logo. Clicking on will redirect you to the home page."}})])])],1),_vm._v(" "),_c('div',{staticClass:"confirm-content"},[_c('div',{staticClass:"confirm-content--order"},[(_vm.guest)?_c('ul',_vm._l((_vm.guestCart),function(item){return _c('li',{staticClass:"confirmed-item"},[_c('div',{staticClass:"confirmed-item--top",attrs:{"data-item":item.id}},[_c('h3',{staticClass:"tertiary-heading confirmed-item--name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading confirmed-item--quantity"},[_vm._v("x "+_vm._s(item.qty))]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading confirmed-item--price"},[_vm._v("$"+_vm._s(item.price))])]),_vm._v(" "),_c('div',{staticClass:"confirmed-item--bottom"},[(item.desc !== item.name)?_c('h4',{staticClass:"primary-copy"},[_vm._v(_vm._s(item.desc))]):_vm._e(),_vm._v(" "),(item.specialInstructions)?_c('h4',{staticClass:"primary-copy special-instructions"},[_vm._v("("+_vm._s(item.specialInstructions)+")")]):_vm._e()])])})):_c('ul',_vm._l((_vm.backendCart),function(item){return _c('li',{staticClass:"confirmed-item"},[_c('div',{staticClass:"confirmed-item--top",attrs:{"data-item":item.id}},[_c('h3',{staticClass:"tertiary-heading confirmed-item--name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading confirmed-item--quantity"},[_vm._v("x "+_vm._s(item.qty))]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading confirmed-item--price"},[_vm._v("$"+_vm._s(item.price))])]),_vm._v(" "),_c('div',{staticClass:"confirmed-item--bottom"},[(item.desc !== item.name)?_c('h4',{staticClass:"primary-copy"},[_vm._v(_vm._s(item.desc))]):_vm._e(),_vm._v(" "),(item.specialInstructions)?_c('h4',{staticClass:"primary-copy special-instructions"},[_vm._v("("+_vm._s(item.specialInstructions)+")")]):_vm._e()])])})),_vm._v(" "),_c('div',{staticClass:"confirm-total"},[_c('div',{staticClass:"confirm-total--subtotal"},[_c('h2',{staticClass:"subheading confirm-total-copy"},[_vm._v("Subtotal:")]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading confirm-total-number"},[_vm._v("$"+_vm._s(_vm.subTotal))])]),_vm._v(" "),_c('div',{staticClass:"confirm-total--taxes"},[_c('h2',{staticClass:"subheading confirm-total-copy"},[_vm._v("HST:")]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading confirm-total-number"},[_vm._v("$"+_vm._s(_vm.hst))])]),_vm._v(" "),_c('div',{staticClass:"confirm-total--total"},[_c('h2',{staticClass:"subheading confirm-total-copy"},[_vm._v("Total:")]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading confirm-total-number"},[_vm._v("$"+_vm._s(_vm.total))])])])]),_vm._v(" "),_c('div',{staticClass:"confirm-content--payment"},[_c('form',{staticClass:"payment-form",on:{"submit":function($event){$event.preventDefault();}}},[(_vm.locationData.pay_later === 1)?_c('div',{staticClass:"payment-form--toggle"},[_c('h3',{staticClass:"tertiary-heading",class:{red: !_vm.payLater}},[_vm._v("Pay Now")]),_vm._v(" "),_c('label',{staticClass:"switch",attrs:{"for":"payment-form--type"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payLater),expression:"payLater"}],attrs:{"type":"checkbox","id":"payment-form--type"},domProps:{"checked":Array.isArray(_vm.payLater)?_vm._i(_vm.payLater,null)>-1:(_vm.payLater)},on:{"change":function($event){var $$a=_vm.payLater,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.payLater=$$a.concat([$$v]))}else{$$i>-1&&(_vm.payLater=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.payLater=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"slider"})]),_vm._v(" "),_c('h3',{staticClass:"tertiary-heading",class:{red: _vm.payLater}},[_vm._v("Pay Later")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"payment-form--universal"},[(_vm.locationData.delivery === 1)?_c('div',{staticClass:"order-type-container"},[_c('label',{staticClass:"tertiary-heading",attrs:{"for":"order-type"}},[_vm._v("Order for: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderType),expression:"orderType"}],staticClass:"order-select order-type tertiary-heading",attrs:{"id":"order-type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.orderType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"delivery"}},[_vm._v("Delivery")]),_vm._v(" "),_c('option',{attrs:{"value":"pickup"}},[_vm._v("Pickup")])]),_vm._v(" "),_vm._m(0,false,false)]):_vm._e(),_vm._v(" "),(_vm.orderType === 'delivery')?_c('h5',{staticClass:"tertiary-heading"},[_vm._v(" *All delivery orders are cash only ")]):_vm._e(),_vm._v(" "),(_vm.orderType === 'delivery')?_c('div',{staticClass:"delivery-details"},[(_vm.guest)?_c('div',{staticClass:"delivery-details--guest"},[_c('label',{staticClass:"tertiary-heading",attrs:{"for":"guestAddress"}},[_vm._v("Address:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestData.address),expression:"guestData.address"}],staticClass:"primary-copy",attrs:{"type":"text","id":"guestAddress"},domProps:{"value":(_vm.guestData.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guestData, "address", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"guestPostal"}},[_vm._v("Postal Code:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestData.postal),expression:"guestData.postal"}],staticClass:"primary-copy",attrs:{"type":"text","id":"guestPostal"},domProps:{"value":(_vm.guestData.postal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guestData, "postal", $event.target.value)}}})]):_c('div',{staticClass:"delivery-details--user"},[_c('h3',{staticClass:"tertiary-heading"},[_vm._v("Delivery Details:")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"primary-copy"},[_vm._v("Name: "+_vm._s(_vm.userData.firstName + ' ' + _vm.userData.lastName))]),_vm._v(" "),_c('li',{staticClass:"primary-copy"},[_vm._v("Email: "+_vm._s(_vm.userData.email))]),_vm._v(" "),_c('li',{staticClass:"primary-copy"},[_vm._v("Phone: "+_vm._s(_vm.userData.phone))]),_vm._v(" "),_c('li',{staticClass:"primary-copy"},[_vm._v("Address: "+_vm._s(_vm.userData.address))]),_vm._v(" "),_c('li',{staticClass:"primary-copy"},[_vm._v("Postal Code: "+_vm._s(_vm.userData.postal))])])])]):_vm._e(),_vm._v(" "),(_vm.orderType === 'pickup')?_c('div',{staticClass:"order-time-container"},[_c('label',{staticClass:"tertiary-heading",attrs:{"for":"orderLater"}},[_vm._v("Pickup time: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderLater),expression:"orderLater"}],staticClass:"order-select order-time tertiary-heading",attrs:{"id":"orderLater"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.orderLater=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"false","selected":""}},[_vm._v("as soon as possible.")]),_vm._v(" "),_c('option',{attrs:{"value":"true"}},[_vm._v("later.")])]),_vm._v(" "),_vm._m(1,false,false)]):_vm._e(),_vm._v(" "),(_vm.orderLater === 'true' && _vm.orderType === 'pickup')?_c('el-date-picker',{attrs:{"id":"datePicker","type":"datetime","placeholder":"Select date and time.","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.orderDate),callback:function ($$v) {_vm.orderDate=$$v},expression:"orderDate"}}):_vm._e()],1),_vm._v(" "),(!_vm.payLater)?_c('div',{staticClass:"payment-form--pay-now"},[_c('div',{staticClass:"payment-option"},[_c('div',{staticClass:"order-time-container"},[_c('label',{staticClass:"tertiary-heading",attrs:{"for":"card-type"}},[_vm._v("Paying with:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardType),expression:"cardType"}],staticClass:"order-select card-type tertiary-heading",staticStyle:{"pointer-events":"none"},attrs:{"id":"card-type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cardType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"credit","selected":""}},[_vm._v("Credit")])])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","align-items":"center"}},[(_vm.cardType === 'debit')?_c('iframe',{attrs:{"id":"monerisFrame","src":_vm.monerisDebitUrl,"frameborder":"0"}}):_vm._e(),_vm._v(" "),(_vm.cardType === 'credit')?_c('iframe',{attrs:{"id":"monerisFrame","src":_vm.monerisCreditUrl,"frameborder":"0"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-buttons"},[_c('button',{staticClass:"place-order",on:{"click":_vm.requestToken}},[_vm._v("Place Order")]),_vm._v(" "),_c('button',{staticClass:"place-order",on:{"click":_vm.editOrder}},[_vm._v("Edit Order")])])]):_c('div',{staticClass:"payment-form--pay-later"},[_c('div',{staticClass:"order-buttons"},[_c('button',{staticClass:"place-order",on:{"click":_vm.handlePlaceOrder}},[_vm._v("Place Order")]),_vm._v(" "),_c('button',{staticClass:"place-order",on:{"click":_vm.editOrder}},[_vm._v("Edit Order")])])])])])])])])}
var ConfirmOrder_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"select-icon"},[_c('i',{staticClass:"fa fa-caret-down"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"select-icon"},[_c('i',{staticClass:"fa fa-caret-down"})])}]
var ConfirmOrder_esExports = { render: ConfirmOrder_render, staticRenderFns: ConfirmOrder_staticRenderFns }
/* harmony default export */ var components_ConfirmOrder = (ConfirmOrder_esExports);
// CONCATENATED MODULE: ./src/components/ConfirmOrder.vue
function ConfirmOrder_injectStyle (ssrContext) {
  __webpack_require__("QMKg")
}
var ConfirmOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ConfirmOrder___vue_template_functional__ = false
/* styles */
var ConfirmOrder___vue_styles__ = ConfirmOrder_injectStyle
/* scopeId */
var ConfirmOrder___vue_scopeId__ = "data-v-0702cc6b"
/* moduleIdentifier (server only) */
var ConfirmOrder___vue_module_identifier__ = null
var ConfirmOrder_Component = ConfirmOrder_normalizeComponent(
  ConfirmOrder["a" /* default */],
  components_ConfirmOrder,
  ConfirmOrder___vue_template_functional__,
  ConfirmOrder___vue_styles__,
  ConfirmOrder___vue_scopeId__,
  ConfirmOrder___vue_module_identifier__
)

/* harmony default export */ var src_components_ConfirmOrder = (ConfirmOrder_Component.exports);

// EXTERNAL MODULE: ./src/controllers/Orders.js
var Orders = __webpack_require__("6+h/");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Order.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Order = ({
	name: 'Order',
	props: ['cartOpenedRemotely'],
	created: function created() {
		if (this.cartOpenedRemotely) {
			this.cartOpen = !this.cartOpen;
		}
	},
	mounted: function mounted() {
		console.log(global["a" /* default */].getLocation());
		console.log(this.$root.categories);
	},
	data: function data() {
		return {
			dropdownOpen: false,
			selectedIndex: 0,
			selectedItem: {},
			viewingItem: false,
			cartOpen: false,
			navOpen: false,
			location: global["a" /* default */].getLocation()
		};
	},

	computed: {
		cart: function cart() {
			return this.$root.cart;
		},
		totalItems: function totalItems() {
			var totalItems = 0;
			this.cart.forEach(function (item) {
				totalItems = totalItems + item.qty;
			});
			return totalItems;
		},
		loggedIn: function loggedIn() {
			return this.$root.loggedIn;
		},
		itemsDisplayed: function itemsDisplayed() {
			if (this.selectedCategory) {
				return this.selectedCategory.items;
			} else {
				return [];
			}
		},
		categoryDesc: function categoryDesc() {
			var desc = '';
			if (this.itemsDisplayed) {
				this.itemsDisplayed.forEach(function (item) {
					if (item.price === '0.00') {
						desc = item.desc;
					}
				});
			}
			return desc;
		}
	},
	methods: {
		toggleDropdown: function toggleDropdown() {
			console.log('dropdown');
			this.dropdownOpen = !this.dropdownOpen;
		},
		setIndex: function setIndex(index) {
			this.selectedIndex = index;
			// this.$set(this.selectedIndex = index)
			console.log(this.selectedIndex);
		},
		viewItem: function viewItem(item) {
			var newItem = {
				name: item.name,
				desc: item.desc,
				price: item.price,
				id: item.id,
				qty: 1,
				edit: false
			};
			this.selectedItem = assign_default()({}, newItem);
			this.viewingItem = !this.viewingItem;
		},
		incrementQty: function incrementQty() {
			this.selectedItem.qty++;
		},
		decrementQty: function decrementQty() {
			this.selectedItem.qty--;
		},
		closeItem: function closeItem(cameFromCart) {
			this.viewingItem = !this.viewingItem;
			if (cameFromCart) {
				this.cartOpen = !this.cartOpen;
			}
		},
		openItem: function openItem() {
			this.viewingItem = true;
		},
		handleAddItem: function handleAddItem(specialInstructions) {
			var formattedPrice = parseFloat(this.selectedItem.price).toFixed(2);
			var newItem = {
				id: this.selectedItem.id,
				name: this.selectedItem.name,
				qty: this.selectedItem.qty,
				specialInstructions: specialInstructions,
				price: formattedPrice
			};
			this.$emit('addItem', newItem);
		},
		toggleCart: function toggleCart() {
			jquery_default()('.hamburger').toggleClass('open');
			this.cartOpen = !this.cartOpen;
		},
		editItem: function editItem(id) {
			var _this = this;

			this.cart.forEach(function (item) {
				if (item.id === id) {
					var newItem = {
						name: item.name,
						desc: item.desc,
						price: item.price,
						id: item.id,
						qty: item.qty,
						edit: true
					};
					_this.selectedItem = assign_default()({}, newItem);
				}
			});
			this.viewingItem = !this.viewingItem;
			this.cartOpen = !this.cartOpen;
		},
		removeItem: function removeItem(id) {
			var _this2 = this;

			this.cart.forEach(function (item, index) {
				if (item.id === id) {
					_this2.cart.splice(index, 1);
				}
			});
		},
		handleCheckout: function handleCheckout() {
			this.checkout(this.cart);
		},
		checkout: function checkout(cart) {
			var _this3 = this;

			if (this.$root.loggedIn && !this.$root.guest) {
				cart.forEach(function (item, index) {
					var itemObj = {
						'location_id': _this3.location,
						'item_id': item.id,
						'item_qty': item.qty,
						'base_price': item.price,
						'actual_price': item.price,
						'item_order': 1,
						'modifiers': []
					};
					if (_this3.$root.cartId !== 0) {
						itemObj.cart_id = _this3.$root.cartId;
					}
					Orders["a" /* default */].addToCart(itemObj).then(function (response) {
						_this3.$root.cartId = response.payload.items[0].cart_id;
					}).catch(function (e) {
						console.log('error adding item to cart');
					});
				});
				this.loadCartData();
				this.$router.push('/confirmOrder');
			} else if (this.$root.guest) {
				this.$router.push('/confirmOrder');
			} else {
				this.$router.push('/login');
			}
		},
		getCart: function getCart() {
			var _this4 = this;

			Orders["a" /* default */].getCart(this.$root.cartId).then(function (response) {
				_this4.$root.backendCart = response.payload.items.map(function (item) {
					return {
						id: item.id,
						qty: item.item_qty,
						name: item.name,
						price: item.actual_price.toFixed(2)
					};
				});
			}).catch(function (e) {
				console.log('error getting cart');
			});
		},
		openNav: function openNav() {
			jquery_default()('.hamburger').toggleClass('open');
			this.navOpen = !this.navOpen;
		},
		openHours: function openHours() {
			this.$emit('openHours');
		}
	},
	components: {
		ItemViewer: src_components_ItemViewer,
		Cart: src_components_Cart,
		ConfirmOrder: src_components_ConfirmOrder
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa2ef1f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
var Order_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-container",class:{ cartOpen: _vm.cartOpen }},[_vm._m(0,false,false),_vm._v(" "),_c('main',{staticClass:"menu"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"menu-nav"},[_c('el-dropdown',{staticStyle:{"font-family":"'Raleway', sans-serif","font-weight":"bold","font-size":"25px"},attrs:{"hide-on-click":true,"placement":"top-start"},on:{"command":_vm.setIndex}},[_c('span',{staticClass:"el-dropdown-link"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$root.categories[_vm.selectedIndex].name)+" "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.$root.categories),function(category,i){return (category.items.length > 0 && category.items[0].price !== '0.00')?_c('el-dropdown-item',{key:category.id,attrs:{"command":i}},[_vm._v(" "+_vm._s(category.name))]):_vm._e()}))],1),_vm._v(" "),_c('div',{staticClass:"cart-button",on:{"click":_vm.toggleCart}},[_c('i',{staticClass:"fa fa-shopping-cart",staticStyle:{"font-size":"40px","margin-right":"14px"}}),_vm._v(" "),(_vm.totalItems > 0)?_c('div',{staticClass:"cart-counter"},[_c('span',[_vm._v(_vm._s(_vm.totalItems))])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"items"},[_c('ul',_vm._l((_vm.$root.categories[_vm.selectedIndex].items),function(item){return (item.price !== '0.00')?_c('li',{staticClass:"menu-item",attrs:{"id":item.id},on:{"click":function($event){_vm.viewItem(item)}}},[_c('div',{staticClass:"menu-item--top",attrs:{"id":item.id}},[_c('h3',{staticClass:"tertiary-heading"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('h4',{staticClass:"tertiary-heading menu-item--price"},[_vm._v("$"+_vm._s(item.price))])]),_vm._v(" "),_c('div',{staticClass:"menu-item--bottom"},[(item.desc !== item.name)?_c('h4',{staticClass:"primary-copy menu-item--desc"},[_vm._v(_vm._s(item.desc))]):_vm._e()])]):_vm._e()}))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('item-viewer',{staticClass:"item-viewer",attrs:{"selectedItem":_vm.selectedItem,"viewingItem":_vm.viewingItem},on:{"close":_vm.closeItem,"addItem":_vm.handleAddItem,"addOne":_vm.incrementQty,"subtractOne":_vm.decrementQty}})],1),_vm._v(" "),_c('cart',{staticClass:"cart",class:{open: _vm.cartOpen},staticStyle:{"transition":"all 0s!important"},attrs:{"cartOpen":_vm.cartOpen},on:{"close":_vm.toggleCart,"edit":_vm.editItem,"remove":_vm.removeItem,"checkout":_vm.handleCheckout}})],1)])])}
var Order_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"order-hero"},[_c('div',{staticClass:"wrapper"},[_c('h1',{staticClass:"heading"},[_vm._v("Menu ")])])])}]
var Order_esExports = { render: Order_render, staticRenderFns: Order_staticRenderFns }
/* harmony default export */ var components_Order = (Order_esExports);
// CONCATENATED MODULE: ./src/components/Order.vue
function Order_injectStyle (ssrContext) {
  __webpack_require__("1we+")
}
var Order_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Order___vue_template_functional__ = false
/* styles */
var Order___vue_styles__ = Order_injectStyle
/* scopeId */
var Order___vue_scopeId__ = "data-v-3aa2ef1f"
/* moduleIdentifier (server only) */
var Order___vue_module_identifier__ = null
var Order_Component = Order_normalizeComponent(
  Order,
  components_Order,
  Order___vue_template_functional__,
  Order___vue_styles__,
  Order___vue_scopeId__,
  Order___vue_module_identifier__
)

/* harmony default export */ var src_components_Order = (Order_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/controllers/Users.js




/* harmony default export */ var Users = ({
	login: function login(obj) {
		return new promise_default.a(function (resolve, reject) {
			global["a" /* default */].$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/user/login',
				data: stringify_default()(obj),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error) {
					reject(_error);
				}
			}, true);
		});
	},
	signUp: function signUp(obj) {
		return new promise_default.a(function (resolve, reject) {
			global["a" /* default */].$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/user/register?lang=fr&platform=ios&app_version=1.1.10',
				data: stringify_default()(obj),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error2) {
					reject(_error2);
				}
			}, true);
		});
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MyNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MyNav = ({
	name: 'MyNav',
	data: function data() {
		return {
			navOpen: false
		};
	},

	methods: {
		openNav: function openNav() {
			jquery_default()('.hamburger').toggleClass('open');
			this.navOpen = !this.navOpen;
		},
		handleOpenHours: function handleOpenHours() {
			this.$emit('openHours');
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a3cf36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyNav.vue
var MyNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navs"},[_c('transition',{attrs:{"name":"fade"}},[(this.$route.path !== '/order')?_c('nav',{staticClass:"main-nav"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/","tag":"a"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/order","tag":"a"}},[_vm._v("Menu/Order")])],1),_vm._v(" "),_c('li',[_c('button',{staticClass:"hours-button",on:{"click":_vm.handleOpenHours}},[_vm._v("Hours")])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/","tag":"a","hash":"#contact"}},[_vm._v("Contact")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/","tag":"a","href":"#contact"}},[_vm._v("Catering")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/gallery","tag":"a"}},[_vm._v("Photo Gallery")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/reviews","tag":"a"}},[_vm._v("Reviews")])],1)])]):_vm._e()]),_vm._v(" "),(this.$route.path === '/order')?_c('div',{staticClass:"order-nav",on:{"click":_vm.openNav}},[_vm._m(0,false,false)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hamburger-nav",on:{"click":_vm.openNav}},[_vm._m(1,false,false)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.navOpen)?_c('nav',{staticClass:"mobile-nav",on:{"click":_vm.openNav}},[_c('div',{staticClass:"wrapper"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/","tag":"a"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/order","tag":"a"}},[_vm._v("Menu/Order")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"hash":"contact"}},[_vm._v("Contact")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"tag":"a","href":"#gallery"}},[_vm._v("Photo Gallery")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/reviews","tag":"a"}},[_vm._v("Reviews")])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#catering"}},[_vm._v("Catering")])])])])]):_vm._e()])],1)}
var MyNav_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div',[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div',[_c('span')])])}]
var MyNav_esExports = { render: MyNav_render, staticRenderFns: MyNav_staticRenderFns }
/* harmony default export */ var components_MyNav = (MyNav_esExports);
// CONCATENATED MODULE: ./src/components/MyNav.vue
function MyNav_injectStyle (ssrContext) {
  __webpack_require__("hzrk")
}
var MyNav_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MyNav___vue_template_functional__ = false
/* styles */
var MyNav___vue_styles__ = MyNav_injectStyle
/* scopeId */
var MyNav___vue_scopeId__ = "data-v-12a3cf36"
/* moduleIdentifier (server only) */
var MyNav___vue_module_identifier__ = null
var MyNav_Component = MyNav_normalizeComponent(
  MyNav,
  components_MyNav,
  MyNav___vue_template_functional__,
  MyNav___vue_styles__,
  MyNav___vue_scopeId__,
  MyNav___vue_module_identifier__
)

/* harmony default export */ var src_components_MyNav = (MyNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Login = ({
	name: 'Login',
	components: {
		MyNav: src_components_MyNav
	},
	data: function data() {
		return {
			formType: 'guest',
			loginData: {
				user: '',
				password: ''
			},
			signupData: {
				email: '',
				firstName: '',
				lastName: '',
				phone: '',
				address: '',
				postalCode: '',
				password: '',
				confirmPassword: ''
			},
			guestData: {
				firstName: '',
				lastName: '',
				email: '',
				phone: ''
			},
			error: false,
			errorTitle: '',
			errorMessage: ''
		};
	},

	methods: {
		toggleForm: function toggleForm(nextForm) {
			this.formType = nextForm;
		},
		handleLogin: function handleLogin() {
			if (this.loginData.user && this.loginData.password) {
				this.login(this.loginData);
			} else {
				this.error = !this.error;
				this.errorTitle = 'Login Failed.';
				this.errorMessage = 'Both email and password are required.';
			}
		},
		login: function login(obj) {
			var _this = this;

			Users.login(obj).then(function (response) {
				_this.$root.loggedIn = true;
				_this.$root.userData = response.payload;
				_this.$root.brandId = response.payload.application.brand_id;
				_this.$router.push({ name: 'Order', params: { cartOpenedRemotely: true } });
			}).catch(function (reason) {
				console.log(reason);
			});
		},
		handleSignup: function handleSignup() {
			var title = 'Signup Failed.';
			if (!this.signupData.email) {
				jquery_default()('#newEmail').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'Email is required';
			} else if (!this.signupData.firstName) {
				jquery_default()('#newFirstName').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'First name is required';
			} else if (!this.signupData.lastName) {
				jquery_default()('#newLastName').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'Last name is required';
			} else if (!this.signupData.address) {
				jquery_default()('#newAddress').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'Address is required';
			} else if (!this.signupData.postalCode) {
				jquery_default()('#newPostalCode').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'Postal code is required';
			} else if (!this.signupData.password) {
				jquery_default()('#newPassword').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'Password is required';
			} else if (!this.signupData.confirmPassword) {
				jquery_default()('#confirmNewPassword').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'Password confirmation is required';
			} else if (this.signupData.password !== this.signupData.confirmPassword) {
				jquery_default()('#newPassword, #confirmNewPassword').addClass('missing');
				this.error = !this.error;
				this.errorTitle = title;
				this.errorMessage = 'Password and password confirmation must match.';
			} else {
				this.signup(this.signupData);
			}
		},
		handleGuest: function handleGuest() {
			this.errorTitle = 'Guest signup failed.';
			this.errorMessage = 'All fields required.';
			if (!this.guestData.firstName) {
				jquery_default()('#guestFirstName').addClass('missing');
				this.error = !this.error;
			} else if (!this.guestData.lastName) {
				jquery_default()('#guestLastName').addClass('missing');
				this.error = !this.error;
			} else if (!this.guestData.email) {
				jquery_default()('#guestEmail').addClass('missing');
				this.error = !this.error;
			} else if (!this.guestData.phone) {
				jquery_default()('#guestPhone').addClass('missing');
				this.error = !this.error;
			} else {
				this.guestSignup(this.guestData);
			}
		},
		guestSignup: function guestSignup(guestInfo) {
			this.$root.loggedIn = true;
			this.$root.guest = true;
			this.$root.guestData = guestInfo;
			this.$root.guestData.phone = parseInt(guestInfo.phone);
			this.$router.push({ name: 'ConfirmOrder' });
		},
		closeError: function closeError() {
			this.error = !this.error;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb0e14e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"login",staticStyle:{"height":"100vh","display":"inline-block"}},[_c('div',{staticClass:"login-nav",staticStyle:{"width":"100%","margin":"0 auto","margin-top":"50px!important"}},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"img-box login",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('img',{staticStyle:{"width":"200px !important"},attrs:{"src":__webpack_require__("rNDY"),"alt":"An image of our logo. Clicking on will redirect you to the home page."}})])])],1),_vm._v(" "),_c('div',{staticClass:"wrapper"},[(_vm.formType === 'login')?_c('form',{staticClass:"login-form",on:{"submit":function($event){$event.preventDefault();}}},[_c('h2',{staticClass:"subheading"},[_vm._v("Please login to place an order.")]),_vm._v(" "),_c('h3',{staticClass:"primary-copy"},[_vm._v("Don't have an account? "),_c('button',{staticClass:"toggle-form",on:{"click":function($event){_vm.toggleForm('signup')}}},[_vm._v("Sign Up")]),_vm._v(" or "),_c('button',{staticClass:"toggle-form",on:{"click":function($event){_vm.toggleForm('guest')}}},[_vm._v("Login as guest.")])]),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"user"}},[_vm._v("Email:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginData.user),expression:"loginData.user"}],staticClass:"primary-copy",attrs:{"type":"email","id":"user"},domProps:{"value":(_vm.loginData.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginData, "user", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"password"}},[_vm._v("Password:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginData.password),expression:"loginData.password"}],staticClass:"primary-copy",attrs:{"type":"password","id":"password"},domProps:{"value":(_vm.loginData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginData, "password", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"button","value":"Login"},on:{"click":_vm.handleLogin}})]):_vm._e(),_vm._v(" "),(_vm.formType === 'signup')?_c('form',{staticClass:"signup-form",on:{"submit":function($event){$event.preventDefault();}}},[_c('h2',{staticClass:"subheading"},[_vm._v("Sign Up")]),_vm._v(" "),_c('div',{staticClass:"signup-form-content"},[_c('div',{staticClass:"form-left"},[_c('label',{staticClass:"tertiary-heading",attrs:{"for":"newEmail"}},[_vm._v("Email:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.email),expression:"signupData.email"}],staticClass:"primary-copy",attrs:{"type":"email","id":"newEmail"},domProps:{"value":(_vm.signupData.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"newFirstName"}},[_vm._v("First Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.firstName),expression:"signupData.firstName"}],staticClass:"primary-copy",attrs:{"type":"text","id":"newFirstName"},domProps:{"value":(_vm.signupData.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "firstName", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"newLastName"}},[_vm._v("Last Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.lastName),expression:"signupData.lastName"}],staticClass:"primary-copy",attrs:{"type":"text","id":"newLastName"},domProps:{"value":(_vm.signupData.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "lastName", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"newPhone"}},[_vm._v("Phone Number:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.phone),expression:"signupData.phone"}],staticClass:"primary-copy",attrs:{"type":"text","id":"newPhone"},domProps:{"value":(_vm.signupData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-right"},[_c('label',{staticClass:"tertiary-heading",attrs:{"for":"newAddress"}},[_vm._v("Address:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.address),expression:"signupData.address"}],staticClass:"primary-copy",attrs:{"type":"text","id":"newAddress"},domProps:{"value":(_vm.signupData.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "address", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"newPostalCode"}},[_vm._v("Postal Code:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.postalCode),expression:"signupData.postalCode"}],staticClass:"primary-copy",attrs:{"type":"text","id":"newPostalCode"},domProps:{"value":(_vm.signupData.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "postalCode", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"newPassword"}},[_vm._v("Password:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.password),expression:"signupData.password"}],staticClass:"primary-copy",attrs:{"type":"password","id":"newPassword"},domProps:{"value":(_vm.signupData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"tertiary-heading",attrs:{"for":"confirmNewPassword"}},[_vm._v("Confirm Password:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupData.confirmPassword),expression:"signupData.confirmPassword"}],staticClass:"primary-copy",attrs:{"type":"password","id":"confirmNewPassword"},domProps:{"value":(_vm.signupData.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupData, "confirmPassword", $event.target.value)}}})])]),_vm._v(" "),_c('input',{attrs:{"type":"button","value":"Sign Up"},on:{"click":_vm.handleSignup}})]):_vm._e(),_vm._v(" "),(_vm.formType === 'guest')?_c('form',{staticClass:"guest-form",staticStyle:{"display":"table","width":"300px","min-width":"0px","border":"2px solid #223446","padding":"35px","border-radius":"5px"},on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticStyle:{"width":"50%","padding-right":"20px","float":"left","display":"inline-block"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestData.firstName),expression:"guestData.firstName"}],staticClass:"primary-copy",attrs:{"placeholder":"First Name","type":"text","id":"guestFirstName"},domProps:{"value":(_vm.guestData.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guestData, "firstName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","float":"left","display":"inline-block"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestData.lastName),expression:"guestData.lastName"}],staticClass:"primary-copy",attrs:{"placeholder":"Last Name","type":"text","id":"guestLastName"},domProps:{"value":(_vm.guestData.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guestData, "lastName", $event.target.value)}}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestData.email),expression:"guestData.email"}],staticClass:"primary-copy",attrs:{"placeholder":"Email","type":"email","id":"guestEmail"},domProps:{"value":(_vm.guestData.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guestData, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestData.phone),expression:"guestData.phone"}],staticClass:"primary-copy",attrs:{"placeholder":"Phone Number","type":"text","id":"guestPhone"},domProps:{"value":(_vm.guestData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guestData, "phone", $event.target.value)}}}),_vm._v(" "),_c('input',{staticStyle:{"width":"auto!important","float":"right","margin-top":"20px","border-radius":"2px","background-color":"#D00016","color":"white","padding":"5px"},attrs:{"type":"button","value":"Login"},on:{"click":_vm.handleGuest}})]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.error)?_c('div',{staticClass:"errorModal",on:{"click":_vm.closeError}},[_c('div',{staticClass:"errorModal-content"},[_c('h1',{staticClass:"heading"},[_vm._v("Login Failed.")]),_vm._v(" "),_c('h3',{staticClass:"primary-copy"},[_vm._v(_vm._s(_vm.errorMessage))])])]):_vm._e()])],1)])}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("CGH0")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-7bb0e14e"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SuccessfulOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SuccessfulOrder = ({
	name: 'SuccessfulOrder',
	props: ['orderNumber', 'userEmail'],
	components: {
		MyNav: src_components_MyNav
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c1b139","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SuccessfulOrder.vue
var SuccessfulOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"success"},[_c('nav'),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"success-content"},[_c('h1',{staticClass:"heading"},[_vm._v("Order Successfully Placed.")]),_vm._v(" "),_c('h3',{staticClass:"subheading"},[_vm._v("Your order number is: "),_c('span',{staticClass:"order-detail"},[_vm._v(_vm._s(_vm.orderNumber))])]),_vm._v(" "),_c('h3',{staticClass:"subheading"},[_vm._v("An email with your order details has been sent to: "),_c('span',{staticClass:"order-detail"},[_vm._v(_vm._s(_vm.userEmail))])]),_vm._v(" "),_c('router-link',{staticClass:"subheading",staticStyle:{"color":"white","background-color":"#D00016"},attrs:{"to":"/","tag":"button"}},[_vm._v("Back to Home")])],1)])])}
var SuccessfulOrder_staticRenderFns = []
var SuccessfulOrder_esExports = { render: SuccessfulOrder_render, staticRenderFns: SuccessfulOrder_staticRenderFns }
/* harmony default export */ var components_SuccessfulOrder = (SuccessfulOrder_esExports);
// CONCATENATED MODULE: ./src/components/SuccessfulOrder.vue
function SuccessfulOrder_injectStyle (ssrContext) {
  __webpack_require__("c77P")
}
var SuccessfulOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SuccessfulOrder___vue_template_functional__ = false
/* styles */
var SuccessfulOrder___vue_styles__ = SuccessfulOrder_injectStyle
/* scopeId */
var SuccessfulOrder___vue_scopeId__ = "data-v-57c1b139"
/* moduleIdentifier (server only) */
var SuccessfulOrder___vue_module_identifier__ = null
var SuccessfulOrder_Component = SuccessfulOrder_normalizeComponent(
  SuccessfulOrder,
  components_SuccessfulOrder,
  SuccessfulOrder___vue_template_functional__,
  SuccessfulOrder___vue_styles__,
  SuccessfulOrder___vue_scopeId__,
  SuccessfulOrder___vue_module_identifier__
)

/* harmony default export */ var src_components_SuccessfulOrder = (SuccessfulOrder_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js







vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
	routes: [{
		path: '/',
		name: 'Order',
		component: src_components_Order
	}, {
		path: '/confirmOrder',
		name: 'ConfirmOrder',
		component: src_components_ConfirmOrder
	}, {
		path: '/login',
		name: 'Login',
		component: src_components_Login
	}, {
		path: '/success',
		name: 'Success',
		props: true,
		component: src_components_SuccessfulOrder
	}]
}));
// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/locale/lang/en.js
var en = __webpack_require__("wUZ8");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__("bm7V");
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vue_esm["default"].config.productionTip = false;
__webpack_require__("8qvv");
vue_esm["default"].use(vue_scrollto_default.a);

vue_esm["default"].use(element_ui_common_default.a, { locale: en_default.a });

/* eslint-disable no-new */
new vue_esm["default"]({
	el: '#app',
	router: router,
	template: '<App @addItem="handleAddItem"/>',
	components: { App: src_App },
	data: function data() {
		return {
			categories: [],
			loggedIn: false,
			headers: {},
			brandId: 2,
			userData: {},
			guest: false,
			guestData: {},
			cartId: 0,
			cart: [],
			backendCart: [],
			cardToken: ''
		};
	},

	methods: {
		handleAddItem: function handleAddItem(newItem) {
			var _this = this;

			if (!this.cart.length) {
				this.cart.push(newItem);
			} else {
				this.cart.forEach(function (item, index) {
					if (item.id === newItem.id) {
						_this.cart.splice(index, 1);
					}
				});
				this.cart.push(newItem);
			}
		}
	}
});

/***/ }),

/***/ "QMKg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rum2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SREL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_Orders__ = __webpack_require__("6+h/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_js__ = __webpack_require__("3Lce");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_Location__ = __webpack_require__("SjVX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ConfirmOrder',
	data: function data() {
		return {
			payLater: false,
			cardType: 'credit',
			orderType: 'pickup',
			orderDate: '',
			orderLater: 'false',
			guestData: {},
			error: false,
			errorTitle: '',
			errorMessage: '',
			cardToken: '',
			messages: 0,
			loading: false,
			monerisCreditUrl: '',
			monerisDebitUrl: '',
			location: __WEBPACK_IMPORTED_MODULE_2__global_js__["a" /* default */].getLocation(),
			locationData: {}
		};
	},
	created: function created() {
		this.monerisCreditUrl = '\n\t\thttps://www3.moneris.com/HPPtoken/index.php\n\t\t?id=htB1MYU2CE8NKIR\n\t\t&display_labels=2\n\t\t&css_body=background:transparent;\n\t\t&css_textbox=border-width:2px;\n\t\t&css_textbox_pan=\n\t\t\twidth:100%;\n\t\t\toverflow:visible;\n\t\t\theight:40px;\n\t\t\tfont-size:16px;\n\t\t\tmargin-bottom:10px;\n\t\t\tborder:none;\n\t\t\tborder-bottom: 1px solid grey;\n\t\t&enable_exp=1\n\t\t&css_textbox_exp=\n\t\t\twidth:48%;\n\t\t\theight:40px;\n\t\t\tfont-size:16px;\n\t\t\tdisplay:inline-block;\n\t\t\tfloat:left;\n\t\t\tmargin-bottom:10px;\n\t\t\tmargin-right:4%;\n\t\t\tborder:none;\n\t\t\tborder-bottom: 1px solid grey;\n\t\t&enable_cvd=1\n\t\t&css_textbox_cvd=\n\t\t\twidth:48%;\n\t\t\tmargin-left:0%;\n\t\t\tdisplay:inline-block;\n\t\t\theight:40px;\n\t\t\tfont-size:16px;\n\t\t\tborder:none;\n\t\t\tborder-bottom: 1px solid grey;\n\t\t';

		this.monerisDebitUrl = '\n\t\thttps://www3.moneris.com/HPPtoken/index.php\n\t\t?id=htB1MYU2CE8NKIR\n\t\t&display_labels=2\n\t\t&css_body=background:transparent;\n\t\t&css_textbox=border-width:2px;\n\t\t&css_textbox_pan=\n\t\t\twidth:100%;\n\t\t\toverflow:visible;\n\t\t\theight:40px;\n\t\t\tfont-size:16px;\n\t\t\tmargin-bottom:10px;\n\t\t\tborder:none;\n\t\t\tborder-bottom: 1px solid grey;\n\t\t';
	},
	mounted: function mounted() {
		this.getLocationData();
	},

	computed: {
		backendCart: function backendCart() {
			return this.$root.backendCart;
		},

		// if user is guest there is no backend cart, and so we must pull item data from frontend cart
		guestCart: function guestCart() {
			var guestCart = [];
			if (!this.backendCart.length) {
				guestCart = this.$root.cart;
			}
			return guestCart;
		},
		pickupLater: function pickupLater() {
			if (this.orderLater === 'false') {
				return false;
			} else {
				return true;
			}
		},
		userData: function userData() {
			return this.$root.userData;
		},
		guest: function guest() {
			if (this.$root.guest) {
				return true;
			} else {
				return false;
			}
		},
		subTotal: function subTotal() {
			var subTotal = 0;
			if (this.guest) {
				this.guestCart.forEach(function (item) {
					var price = parseFloat(item.price) * parseFloat(item.qty);
					subTotal = subTotal + price;
				});
			} else {
				this.$root.backendCart.forEach(function (item) {
					var price = parseFloat(item.price) * parseFloat(item.qty);
					subTotal = subTotal + price;
				});
			}
			return subTotal.toFixed(2);
		},
		hst: function hst() {
			var subTotal = parseFloat(this.subTotal);
			var taxRate = subTotal < 4 ? 0.5 : 0.13;
			var hst = taxRate * subTotal;
			return hst.toFixed(2);
		},
		total: function total() {
			var hst = parseFloat(this.hst);
			var subTotal = parseFloat(this.subTotal);
			var total = subTotal + hst;
			return total.toFixed(2);
		},
		utcTime: function utcTime() {
			var utcTime = '';
			if (this.orderDate) {
				var date = new Date(this.orderDate);
				var utcArr = [date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()];
				var formattedUtcArr = [];
				utcArr.forEach(function (entry) {
					entry = entry.toString();
					if (entry.length === 1) {
						entry = '0' + entry;
					}
					formattedUtcArr.push(entry);
				});
				utcTime = formattedUtcArr[0] + '-' + formattedUtcArr[1] + '-' + formattedUtcArr[2] + ' ' + formattedUtcArr[3] + ':' + formattedUtcArr[4] + ':' + formattedUtcArr[5];
			}
			return utcTime;
		}
	},
	methods: {
		getLocationData: function getLocationData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_3__controllers_Location__["a" /* default */].getLocation().then(function (response) {
				_this.locationData = response.payload;
			}).catch(function (e) {});
		},
		requestToken: function requestToken() {
			if (this.guest && this.orderType === 'delivery') {
				if (this.guestData.address && this.guestData.postal) {
					var monFrameRef = document.getElementById('monerisFrame').contentWindow;
					monFrameRef.postMessage('', 'https://www3.moneris.com/HPPtoken/index.php');
					window.addEventListener('message', this.receiveToken, false);
					console.log('Token requested');
					return false;
				} else {
					this.error = !this.error;
					this.$message.error('Address and postal code are required for delivery.');
					// this.errorTitle = 'Failed to place order.'
					// this.errorMessage = 'Address and postal code are required for delivery.'
				}
			} else {
				var _monFrameRef = document.getElementById('monerisFrame').contentWindow;
				_monFrameRef.postMessage('', 'https://www3.moneris.com/HPPtoken/index.php');
				window.addEventListener('message', this.receiveToken, false);
				console.log('Token requested');
				return false;
			}
		},
		receiveToken: function receiveToken(e) {
			console.log('message received from', e.origin);
			// this.$message.info('Validating payment info')
			this.messages = 1;
			// eslint-disable-next-line
			var response = eval('(' + e.data + ')');
			this.cardToken = response.dataKey;
			if (this.cardToken !== undefined) {
				// this.$message.success('Payment info validated')
				this.handlePlaceOrder(this.cardToken);
			} else {
				alert('error processing your payment. please try again.');
				this.$message.error('Payment info is not valid');
			}
			console.log('Card Token: ' + this.cardToken);
			window.removeEventListener('message', this.receiveToken, false);
		},
		handlePlaceOrder: function handlePlaceOrder(paymentToken) {
			console.log('handle place order was called');
			var guestOrderPayLater = {
				payLater: 1,
				pickuplater: this.pickupLater,
				pickupdatetime: this.utcTime,
				checkoutType: 'guest',
				user: this.$root.guestData,
				items: this.guestCart
			};

			var guestOrderPayNow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, guestOrderPayLater, { payLater: 0, token: paymentToken });

			var userOrderPayLater = {
				payLater: 1,
				pickup: this.pickupLater,
				pickupdatetime: this.utcTime,
				checkoutType: 'registered',
				user: this.$root.userData,
				cartId: this.$root.cartId
			};

			var userOrderPayNow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, userOrderPayLater, { payLater: 0, token: paymentToken });

			if (this.guest && this.payLater) {
				console.log('placing guestOrderPayLater', guestOrderPayLater);
				this.placeOrder(guestOrderPayLater);
			}
			if (this.guest && !this.payLater) {
				console.log('placing guest order pay now');
				this.placeOrder(guestOrderPayNow);
			}
			if (!this.guest && this.payLater) {
				console.log('placing user order pay later');
				this.placeOrder(userOrderPayLater);
			}
			if (!this.guest && !this.payLater) {
				console.log('placing user order pay now');
				this.placeOrder(userOrderPayNow);
			}
		},
		placeOrder: function placeOrder(obj) {
			var _this2 = this;

			this.loading = true;
			var items = obj.items.map(function (item) {
				return {
					'item_id': item.id,
					'item_qty': item.qty,
					'base_price': item.price,
					'actual_price': item.price,
					'item_order': 1,
					'modifiers': []
				};
			});
			var cartObj = {
				'location_id': this.location,
				'pickup_later': obj.pickupLater, // bool
				'pay_later': obj.payLater, // 1 or 0
				'pickupdatetime': obj.pickupdatetime,
				'checkout_type': obj.checkoutType, // 'guest'
				'payment_token': obj.token,
				'cart_type': 'regular',
				'gateway_name': 'moneris',
				'user': {
					'first_name': obj.user.firstName,
					'last_name': obj.user.lastName,
					'email': obj.user.email,
					'phone': obj.user.phone,
					'brand_id': this.$root.brandId
				}
			};
			if (obj.checkoutType === 'guest') {
				cartObj.items = items;
			} else if (obj.checkoutType === 'registered') {
				cartObj.cart_id = obj.cartId;
			}
			__WEBPACK_IMPORTED_MODULE_1__controllers_Orders__["a" /* default */].placeOrder(cartObj).then(function (response) {
				_this2.$message.success('Successfully placed order!');
				_this2.$router.push({
					name: 'Success',
					params: {
						orderNumber: response.payload.external_id,
						userEmail: obj.user.email
					}
				});
			}).catch(function (e) {
				_this2.$message.error('Error: ' + e.responseJSON.message);
				console.log('error placing order');
			});
		},
		editOrder: function editOrder() {
			this.$emit('editFromConfirmation');
			this.$router.push({ name: 'Order', params: { cartOpenedRemotely: true } });
		},
		closeError: function closeError() {
			this.error = !this.error;
		}
	}
});

/***/ }),

/***/ "SjVX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__("3Lce");



/* harmony default export */ __webpack_exports__["a"] = ({
	getLocation: function getLocation() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].$ajax({
				method: 'GET',
				dataType: 'json',
				url: '/app/locations/show/' + __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].getLocation(),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error) {
					reject(_error);
				}
			}, true);
		});
	},
	getLocationHours: function getLocationHours() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].$ajax({
				method: 'GET',
				dataType: 'json',
				url: '/app/hours/' + __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].getLocation(),
				success: function success(response) {
					resolve(response);
				},
				error: function error(_error2) {
					reject(_error2);
				}
			}, true);
		});
	}
});

/***/ }),

/***/ "ZxdY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c77P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hzrk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j7sp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rNDY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Web-logo.280db1d.png";

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2146c8d56c4577a1117e.js